module.exports = __webpack_public_path__ + "img/塔基.SLDPRT.51ba6804.jpg";